import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-warning-alert',
  templateUrl: './warning-alert.component.html',
  styleUrls: ['./warning-alert.component.scss']
})
export class WarningAlertComponent {
  success: any = false;
  message: any;
  timeLeft: any;
  timer: any;
  resend: any;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private dialogRef: MatDialogRef<WarningAlertComponent>) { }
  ngOnInit(): void {
    this.success = this.data.status;
    this.message = this.data.message;
    this.startTimer();
  }

  startTimer() {
    this.timeLeft = 1;
    this.timer = setInterval(() => {
      if (this.timeLeft > 0) {
        this.timeLeft--;
      } else {
        this.dialogRef.close()
        clearInterval(this.timer);
      }
    }, 1000);
  }

}
